// src/apis/materialReturnApi.ts

import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import {
  LOTInfoDto,
  PDA1080R01ReturnRequest,
} from "../containers/PDA/PDA1080_R01/PDA1080_R01Dto";
import {
  PDA1081_R01ReturnRequest,
  PDA1081_R01ReturnResultDto,
  PDA1081_R01ScanResultDto,
} from "../containers/PDA/PDA1081_R01/PDA1081_R01Dto";
import { getData, postData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1080_R01`;
const baseUrlR02 = `${config.apiUrl}/PDA1081_R01`;

// ========== PDA1080_R01 자재반입 API ==========

/**
 * LOT 스캔 및 정보 조회
 * 
 * LOT 번호로 자재 정보를 조회합니다.
 * - 품목명, 규격, 현재 재고, 보관위치 등을 반환
 * 
 * @param lotNo LOT 번호
 * @returns LOT 정보 (품목, 재고, 보관위치 등)
 */
export const scanLot = async (lotNo: string) => {
  const url = `${baseUrl}/scan-lot`;
  return await getData<ResponseDto<LOTInfoDto>>(url, { 
    params: { lotNo } 
  });
};

/**
 * 자재반입 등록
 * 
 * 생산 후 남은 잔량 자재를 창고로 반입 처리합니다.
 * - 재고 증가 (wms_stock, wms_stock_lot)
 * - Transport 생성 (입고 실적)
 * - WMS Order 업데이트
 * 
 * @param request 반입 요청 데이터 (LOT, 품목, 수량 등)
 * @returns 처리 결과 메시지
 */
export const returnMaterial = async (request: PDA1080R01ReturnRequest) => {
  const url = `${baseUrl}/return`;
  return await postData<PDA1080R01ReturnRequest, ResponseDto<string>>(url, request);
};

// ========== PDA1081_R01 자재반입 (itemCd 스캔 FIFO) API ==========

/** itemCd 스캔 검증 */
export const scanItemR02 = async (scanValue: string) => {
  const url = `${baseUrlR02}/scan/${encodeURIComponent(scanValue)}`;
  return await getData<ResponseDto<PDA1081_R01ScanResultDto>>(url);
};

/** 자재반입 등록 (일괄) */
export const returnMaterialsR02 = async (request: PDA1081_R01ReturnRequest) => {
  const url = `${baseUrlR02}/return`;
  return await postData<PDA1081_R01ReturnRequest, ResponseDto<PDA1081_R01ReturnResultDto>>(
    url,
    request
  );
};
